module.exports = __webpack_public_path__ + "static/media/golden_pup.8ac5d69f.jpg";